import theme from '../../../../shared/theme';

const Styles = {
    AppBar: {
        position: 'fixed',
        backgroundColor: '#343A40',
        boxShadow: 'none',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        height: 80,
        zIndex: 1299
    },
    Logo: {
        objectFit: 'contain',
        width: 108,
        cursor: 'pointer',
        marginTop: '23px',
        marginLeft: '2px'
    },
    ToolbarContentContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        paddingLeft: '16px'
    },
    ToolbarCategoryMenuContainer: {
        display: 'flex',
        justifyContent: 'start',
        marginTop: '25px',
        '& > *': {
            marginRight: '24px',
            height: '29px',
            opacity: 0.6,
            '&:hover': {
                opacity: 1
            },
            filter: 'brightness(1)'
        }
    },
    CategoryMenuButton: {
        color: 'inherit'
    },
    SupportButton: {
        color: 'inherit',
        '& .MuiButton-endIcon': {
            marginLeft: '4px'
        }
    },
    SeniorLivingButton: {
        color: 'inherit',
        marginLeft: '20px'
    },
    DropdownMenuContainer: {
        marginTop: '21px',
        paddingRight: '8px'
    },
    LogInButton: {
        backgroundColor: '#a6a6a6',
        color: 'white',
        marginRight: '10px',
        padding: '9px 15px',
        fontSize: '14px',
        filter: 'brightness(1)',
        letterSpacing: '0px',
        '&:hover': {
            backgroundColor: '#a6a6a6'
        }
    },
    GetStartedButton: {
        marginRight: '10px',
        paddingTop: '9px',
        paddingBottom: '9px',
        fontSize: '14px',
        letterSpacing: '1px',
        '&:hover': {
            color: 'white',
            backgroundColor: '#ed7d31'
        },
        backgroundColor: '#ed7d31',
        '& .MuiButton-endIcon': {
            marginLeft: '4px'
        },
    },
    GetStartedMenuItem: {
        paddingTop: '9px',
        paddingBottom: '9px',
        paddingLeft: '20px',
        paddingRight: '20px',
        fontSize: 14,
        letterSpacing: '1px',
        backgroundColor: '#343a40',
        textTransform: 'uppercase',
        opacity: .6,
        color: 'white',
        '&:hover': {
            backgroundColor: '#343a40',
            opacity: .8
        }
    },
    Accordion: {
        top: '16px',
        width: '100vw', 
        position: 'fixed', 
        zIndex: 1000,
        '&.MuiAccordion-root:before': {
            backgroundColor: 'transparent'
        }
    },
    AccordionSummary: { 
        minHeight: 0, 
        height: 0, 
        border: 'none' 
    },
    AccordionMenu: {
        display: 'flex',
        justifyContent: 'center',
        paddingLeft: '30vh',
        paddingRight: '30vh',
        backgroundColor: '#343A40'
    }
};

export default Styles;